export const formatAmount = (amount, currency) => {
  console.log("currency", currency);
  
  const amountWithFormatting =
    new Intl.NumberFormat("fr-CM").format(amount) ?? 0;
    const t = amountWithFormatting + " " + currency;
    console.log("t", t);
    
  return t
};
